import { render, staticRenderFns } from "./BacklogTimeReport.vue?vue&type=template&id=263a6748&scoped=true"
import script from "./BacklogTimeReport.vue?vue&type=script&lang=js"
export * from "./BacklogTimeReport.vue?vue&type=script&lang=js"
import style0 from "./BacklogTimeReport.vue?vue&type=style&index=0&id=263a6748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a6748",
  null
  
)

export default component.exports